import { useIntl } from "react-intl";

const ProductRequests = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "ConfluencePricingPage.features.ProductRequests.header",
            defaultMessage: "Product requests"
        }),
        content: intl.formatMessage({
            id: "ConfluencePricingPage.features.ProductRequests.content",
            defaultMessage:
                "Enable admins to manage how and when managed users create Atlassian products."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.content}</p>
        </>
    );
};

export default ProductRequests;
